define('Components/AboutCornerWidget/js/AboutCornerWidget',['hooks',
        'Components/AboutCornerWidget/js/views/AboutCornerWidgetInstanceView',
        'Components/AboutCornerWidget/js/views/AboutCornerHistoryWidgetInstanceView',
        'Components/AboutCornerWidget/js/views/AboutCornerInsightsWidgetInstanceView',
        'Components/AboutCornerWidget/js/views/AboutCornerMapWidgetInstanceView',
        'Components/AboutCornerWidget/js/models/AboutCornerWidgetInstanceModel',
    ],
    function(hooks,AboutCornerWidgetInstanceView, AboutCornerHistoryWidgetInstanceView, AboutCornerInsightsWidgetInstanceView, AboutCornerMapWidgetInstanceView, AboutCornerWidgetInstanceModel){

        return function(){
            hooks.registerWidgetInstance('AboutCornerWidget', {
                    'header': AboutCornerWidgetInstanceView,
                    'history': AboutCornerHistoryWidgetInstanceView,
                    'insights': AboutCornerInsightsWidgetInstanceView,
                    'map': AboutCornerMapWidgetInstanceView,
                },
                AboutCornerWidgetInstanceModel
            );
        }
});
